import React, { useEffect, useState, useRef } from 'react';
import "../styles/clienthistory.css";
import UXHint from "../components/UXHint";
import ClientHelpModal from "../components/ClientHelpModal";
import CommunityProductForm from "../components/CommunityProductForm";
import StoreAutocomplete from "../components/StoreAutocomplete";
import axios from 'axios';
import axiosAuth from '../axios';
import { toast } from 'react-toastify';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Html5Qrcode } from "html5-qrcode";
import { logger } from "../services/logger";
import { trackAction } from "../services/sessionLogger";
import ReportBugButton from "../components/ReportBugButton";
import { getToken, deleteToken } from "firebase/messaging";
import { messaging } from "../firebase-messaging";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { io } from "socket.io-client";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import customMarkerIcon from "../utils/leafletIcon";

const storeMarkerIcon = new L.DivIcon({
  html: '<div style="background:#D41A6E;width:22px;height:22px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.35);display:flex;align-items:center;justify-content:center;font-size:12px;line-height:22px;text-align:center;">🏪</div>',
  className: "",
  iconSize: [26, 26],
  iconAnchor: [13, 13],
  popupAnchor: [0, -14],
});

const API_URL = "/scans";

let _scansCache = null;
let _scansCacheTs = 0;

const ClientHistory = ({ user, onUserUpdate }) => {
  const [scans, setScans] = useState(_scansCache || []);
  const [filteredScans, setFilteredScans] = useState(_scansCache || []);
  const [loading, setLoading] = useState(!_scansCache);
  const [showScanner, setShowScanner] = useState(false);
  const [scanCooldown, setScanCooldown] = useState(false);
  const [scanFlash, setScanFlash] = useState(false);
  const [productSubscriptions, setProductSubscriptions] = useState({});
  const [subsLoading, setSubsLoading] = useState(true);
  
  const [geolocEnabled, setGeolocEnabled] = useState(() => {
    return localStorage.getItem("geolocEnabled") === "true";
  });

  // --- Résultat immédiat du dernier scan (QR ou barcode) ---
  // Structure normalisée Phase 13 :
  //   { type: "vendor",  product: {...}, vendorData: {...} }  — produit avec vendeur connu
  //   { type: "product", product: {...}, vendorData: null  }  — produit sans lien vendeur
  //   { type: "unknown", product: null,  vendorData: null, barcode: string } — barcode inconnu
  const [lastScanResult, setLastScanResult] = useState(null);
  const [scanStore, setScanStore] = useState("");
  const [scanPrice, setScanPrice] = useState("");
  const [showCommunityForm, setShowCommunityForm] = useState(false);

  const [isSubscribedToPush, setIsSubscribedToPush] = useState(() => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("user")) || {};
      return storedUser.subscribedToPush ?? true;
    } catch {
      return true;
    }
  });

  // ── UI display states (no business logic) ──
  const [activeTab, setActiveTab] = useState("accueil");
  const [activeFilter, setActiveFilter] = useState("Tous");
  const [showHelp, setShowHelp] = useState(false);
  // ── Édition du nom affiché ──
  const [editingName, setEditingName] = useState(false);
  const [editNameValue, setEditNameValue] = useState(user?.name || "");
  // ── Ajout d'un crush depuis un lien externe ──
  const [showAddLink, setShowAddLink] = useState(false);
  const [addLinkUrl, setAddLinkUrl] = useState("");
  const [addLinkTitle, setAddLinkTitle] = useState("");
  const [addLinkNeedsTitle, setAddLinkNeedsTitle] = useState(false);
  const [addLinkLoading, setAddLinkLoading] = useState(false);
  const [addLinkError, setAddLinkError] = useState(null);
  // ── Suppression de compte ──
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletePassword, setDeletePassword] = useState("");
  const [deleteSeedPhrase, setDeleteSeedPhrase] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);

  // ── Données démographiques optionnelles ──
  const [demoGender, setDemoGender] = useState(user?.gender || "non_renseigne");
  const [demoBirthRange, setDemoBirthRange] = useState(() => {
    const by = user?.birthYear;
    if (!by) return "";
    if (by > 2007) return "u18";
    if (by >= 2000) return "18-25";
    if (by >= 1990) return "26-35";
    if (by >= 1975) return "36-50";
    return "50+";
  });
  const [demoSaving, setDemoSaving] = useState(false);

  // ── Magasins favoris ──
  const [favoriteStores, setFavoriteStores] = useState(user?.favoriteStores || []);
  const [favToggling, setFavToggling] = useState(null);

  // ── Magasins CrushNow validés (carte) ──
  const [crushStores, setCrushStores] = useState([]);

  useEffect(() => {
    axiosAuth.get("/stores/map")
      .then(res => setCrushStores(res.data.stores || []))
      .catch(() => {});
  }, []);

  const updateScanStore = async (scanId, location_label) => {
    try {
      await axiosAuth.patch(`/scans/${scanId}/store`, { location_label });
      setScans(prev => prev.map(s => s._id === scanId ? { ...s, location_label } : s));
      if (scanPrice && !isNaN(parseFloat(scanPrice))) {
        await axiosAuth.patch(`/scans/${scanId}/price`, {
          price: parseFloat(scanPrice)
        });
        setScans(prev => prev.map(s =>
          s._id === scanId
            ? { ...s, price: parseFloat(scanPrice), price_source: "user" }
            : s
        ));
        setFilteredScans(prev => prev.map(s =>
          s._id === scanId
            ? { ...s, price: parseFloat(scanPrice), price_source: "user" }
            : s
        ));
      }
      setScanPrice("");
    } catch (err) {
      console.error("Erreur updateScanStore :", err);
    } finally {
      setLastScanResult(null);
      setScanStore("");
    }
  };

  const handleSaveName = async () => {
    if (!editNameValue.trim() || editNameValue.trim() === user?.name) {
      setEditingName(false);
      return;
    }
    try {
      const stored = JSON.parse(localStorage.getItem("user")) || {};
      const token = stored.token;
      await axios.put("/api/auth/update-name", { name: editNameValue.trim() }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      stored.name = editNameValue.trim();
      localStorage.setItem("user", JSON.stringify(stored));
      if (onUserUpdate) onUserUpdate(stored);
      setEditingName(false);
      safeToast(() => toast.success("✅ Nom mis à jour"));
    } catch (err) {
      console.error("Erreur update-name :", err);
      safeToast(() => toast.error("❌ Impossible de mettre à jour le nom"));
    }
  };

  const handleToggleFavoriteStore = async (storeId) => {
    setFavToggling(storeId);
    try {
      const stored = JSON.parse(localStorage.getItem("user")) || {};
      const res = await axiosAuth.post("/auth/favorite-stores/toggle", { storeId });
      const newFavs = res.data.favoriteStores;
      setFavoriteStores(newFavs);
      stored.favoriteStores = newFavs;
      localStorage.setItem("user", JSON.stringify(stored));
      if (onUserUpdate) onUserUpdate(stored);
    } catch (err) {
      console.error('Erreur favoris:', err);
      alert('Erreur: ' + err.message);
      safeToast(() => toast.error("Impossible de mettre a jour les favoris"));
    } finally {
      setFavToggling(null);
    }
  };

  const handleSaveDemographics = async () => {
    setDemoSaving(true);
    try {
      const stored = JSON.parse(localStorage.getItem("user")) || {};
      const token = stored.token;
      const rangeMap = { "u18": 2010, "18-25": 2003, "26-35": 1994, "36-50": 1982, "50+": 1969 };
      const birthYear = demoBirthRange ? rangeMap[demoBirthRange] : null;
      await axios.put("/api/auth/update-demographics", { gender: demoGender, birthYear }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      stored.gender = demoGender;
      stored.birthYear = birthYear;
      localStorage.setItem("user", JSON.stringify(stored));
      if (onUserUpdate) onUserUpdate(stored);
      safeToast(() => toast.success("Profil mis a jour"));
    } catch {
      safeToast(() => toast.error("Impossible de mettre a jour le profil"));
    } finally {
      setDemoSaving(false);
    }
  };

  const readerRef = useRef(null);
  const editNameRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const socket = useRef(null);
  // Verrou ref : empêche les doubles déclenchements parasites du scanner
  // (html5-qrcode peut appeler le callback plusieurs fois sur le même frame)
  const scanningRef = useRef(false);
  const scannerRef = useRef(null);
  const stoppedRef = useRef(false);

  const safeStop = () => {
    if (stoppedRef.current || !scannerRef.current) return;
    stoppedRef.current = true;
    try { scannerRef.current.stop().catch(() => {}); } catch (_) {}
  };

  // Restaure l'onglet actif si on revient depuis GlobalProductPage
  useEffect(() => {
    window.scrollTo(0, 0);
    const state = location.state;
    if (state?.tab) setActiveTab(state.tab);
  }, []);

  // Guard : /client est réservé aux clients — les vendeurs vont sur /dashboard
  useEffect(() => {
    if (user?.role === "vendeur") {
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  useEffect(() => {
    socket.current = io(process.env.REACT_APP_API_BASE_URL || window.location.origin);

    console.log("🔌 Socket connecté :", socket.current.id);

    return () => {
      console.log("🔌 Socket déconnecté proprement :", socket.current.id);
      socket.current.disconnect();
    };
  }, []);

  const userId = user?.id || user?._id;

  // ✅ Helper : rend l’affichage des toasts robuste (évite les pertes/race conditions)
  const safeToast = (fn) => {
    requestAnimationFrame(() => setTimeout(fn, 100));
  };

  // ✅ Vérifie l’état d’abonnement push depuis le backend
  const checkPushStatus = async () => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      if (!storedUser?._id && !storedUser?.id) return;
      const res = await axiosAuth.get(`/push/status/${storedUser._id || storedUser.id}`);
      if (res.data.subscribed !== undefined && res.data.subscribed !== null) {
        setIsSubscribedToPush(res.data.subscribed);
      }
      console.log("🔍 Statut push récupéré :", res.data.subscribed);
    } catch (err) {
      console.warn("⚠️ Impossible de récupérer le statut push :", err.message);
    }
  };

  useEffect(() => {
    checkPushStatus();
  }, []);



  useEffect(() => {
    if (!user) {
      // Vérifie localStorage avant de rediriger — évite le crash si le user prop
      // n'est pas encore propagé après navigate() post-login
      try {
        const stored = JSON.parse(localStorage.getItem("user"));
        if (!stored) window.location.href = "/login";
      } catch {
        window.location.href = "/login";
      }
    }
  }, [user]);

  // ✅ Charger l’historique + préparer les abonnements socket par produit
  useEffect(() => {
    const fetchScans = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        const uid = storedUser?._id || storedUser?.id;

        if (!uid || !token) {
          safeToast(() => toast.error("⛔ Session invalide, veuillez vous reconnecter."));
          setLoading(false);
          return;
        }

        // Cache hit — affichage immédiat si données < 30s
        if (_scansCache && Date.now() - _scansCacheTs < 30_000) {
          setScans(_scansCache);
          setFilteredScans(_scansCache);
          setLoading(false);
          const cachedIds = _scansCache.map(s => s.productId).filter(Boolean);
          cachedIds.forEach(pid => socket.current.emit("subscribeToProduct", pid));
          return;
        }

        console.log("📡 Chargement historique pour :", uid);

        const res = await axiosAuth.get(`${API_URL}/history/${uid}`);

        const list = res.data?.scans || res.data || [];
        _scansCache = list;
        _scansCacheTs = Date.now();
        setScans(list);
        setFilteredScans(list);

        // Abonnements socket aux produits scannés
        const scannedIds = list.map(s => s.productId).filter(Boolean);
        scannedIds.forEach(pid => socket.current.emit("subscribeToProduct", pid));
        socket.current.emit("unsubscribeFromRemovedProducts", scannedIds);

        console.log("📜 Historique récupéré :", list.length, "éléments");
      } catch (err) {
        console.error("❌ Erreur lors du chargement de l'historique :", err);
        safeToast(() => toast.error("Erreur lors du chargement de l’historique."));
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchScans();
    else {
      safeToast(() => toast.error("⛔ Aucun utilisateur connecté."));
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  useEffect(() => {
    async function fetchUserSubscriptions() {
      setSubsLoading(true);
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const uid = storedUser?._id || storedUser?.id;
        if (!uid) return;
        const res = await axiosAuth.get(`/push/by-user/${uid}`);
        const subscribedProducts = res.data?.scannedProductIds || [];
        const subs = {};
        subscribedProducts.forEach(pid => { subs[pid] = true; });
        setProductSubscriptions(subs);
        console.log("🔁 Abonnements produits rechargés :", subscribedProducts);
      } catch (err) {
        console.warn("⚠️ Impossible de recharger les abonnements produits :", err.message);
      } finally {
        setSubsLoading(false);
      }
    }
    fetchUserSubscriptions();
  }, []);

  // ✅ Listeners socket (création/màj/suppression produits) avec respect des préférences
  useEffect(() => {
    if (!socket.current) return;

    const canNotifyGlobally = isSubscribedToPush;

    socket.current.on("productCreated", (newProduct) => {
      const fakeScan = {
        ...newProduct,
        _id: newProduct._id || Math.random().toString(36).slice(2),
        date: new Date(),
        city: "Lieu inconnu",
      };

      // On met à jour les données, même si les notifs sont off
      setScans(prev => [fakeScan, ...prev]);
      setFilteredScans(prev => [fakeScan, ...prev]);

      // Mais on n'affiche le toast que si les notifs globales sont activées
      if (canNotifyGlobally) {
        safeToast(() => toast.success(`🆕 Nouveau produit ajouté : ${newProduct.articleName}`));
      }
    });

    socket.current.on("productUpdated", (updatedProduct) => {
      const applyQRUpdate = (prev) =>
        prev.map(p =>
          p.productId === updatedProduct.productId
            ? { ...p, articleName: updatedProduct.articleName, status: updatedProduct.status, _updated: Date.now() }
            : p
        );
      setScans(applyQRUpdate);
      setFilteredScans(applyQRUpdate);

      // On regarde également l'abonnement par produit
      const productAllowed = productSubscriptions?.[updatedProduct.productId];

      if (canNotifyGlobally && productAllowed) {
        if (updatedProduct?.articleName) {
          safeToast(() => toast.info(
            `🔁 ${updatedProduct.articleName} mis à jour : ${updatedProduct.status || 'changement'}`
          ));
        }
      }
    });

    socket.current.on("productDeleted", (deleted) => {
      const removedId = deleted.productId;

      setScans(prev =>
        prev.filter(scan =>
          scan.productId !== removedId && scan._id !== deleted._id
        )
      );

      setFilteredScans(prev =>
        prev.filter(scan =>
          scan.productId !== removedId && scan._id !== deleted._id
        )
      );

      if (canNotifyGlobally) {
        safeToast(() =>
          toast.warn(`🗑️ ${deleted.articleName || "Un produit"} a été supprimé.`)
        );
      }
    });

    return () => {
      socket.current.off("productCreated");
      socket.current.off("productUpdated");
      socket.current.off("productDeleted");
    };
  }, [isSubscribedToPush, productSubscriptions]);

  // ✅ Listeners socket (messages divers liés à l’utilisateur)
  // ✅ Listeners socket (messages liés à l’utilisateur) avec respect des préférences
  useEffect(() => {
    if (!userId || !socket.current) return;

    socket.current.emit("subscribeToUser", userId);

    const canNotifyGlobally = isSubscribedToPush;

    socket.current.on("statusUpdate", (data) => {
      if (!canNotifyGlobally) return;
      if (data?.articleName && data?.message) {
        safeToast(() => toast.info(`🔔 ${data.articleName} : ${data.message}`));
      }
    });

    socket.current.on("productUpdate", (data) => {
      const productAllowed = productSubscriptions?.[data.productId];
      if (!canNotifyGlobally || !productAllowed) return;

      if (data?.productId && data?.message) {
        safeToast(() => toast.info(`📦 ${data.productId} : ${data.message}`));
      }
    });

    socket.current.on("unsubscribeFromRemovedProducts", (removed) => {
      if (!canNotifyGlobally) return;
      if (Array.isArray(removed)) {
        safeToast(() => toast.info(`🧹 Désabonné de ${removed.length} produit(s).`));
      }
    });

    socket.current.on("newScan", (data) => {
      console.log("📩 Nouveau scan reçu :", data);
      if (!data?.scan) return;

      // Dédoublonnage : ignore si ce scan est déjà dans l'état local
      // (le handler HTTP barcode l'a déjà ajouté avec les données enrichies)
      const scanId = data.scan._id?.toString();
      setScans(prev => {
        if (scanId && prev.some(s => s._id?.toString() === scanId)) return prev;
        return [data.scan, ...prev];
      });
      setFilteredScans(prev => {
        if (scanId && prev.some(s => s._id?.toString() === scanId)) return prev;
        return [data.scan, ...prev];
      });

      // Mais on n'affiche pas le toast si l'utilisateur a coupé les notifs
      if (canNotifyGlobally) {
        safeToast(() => toast.success(`🆕 Nouveau scan : ${data.scan.articleName || "Article inconnu"}`));
      }
    });

    // ✅ Mise à jour temps réel du stock/prix (vendeur a modifié le lien)
    // Couvre deux cas :
    //   1. scan barcode standard (s.vendorLink présent)
    //   2. scan community upgradé (s.upgraded === true, vendorData présent)
    socket.current.on("vendorLinkUpdated", (data) => {
      console.log("🔧 [CLIENT] ✅ vendorLinkUpdated reçu:", data);
      if (!data?.barcode) return;
      const applyUpdate = (prev) =>
        prev.map(s => {
          // Flux barcode standard
          if (s.barcode === data.barcode && s.vendorLink) {
            return { ...s, vendorLink: { ...s.vendorLink, stock: data.stock, price: data.price, customNote: data.customNote } };
          }
          // Flux community upgradé — même barcode, mais vendorData au lieu de vendorLink
          if (s.scanType === "community" && s.barcode === data.barcode && s.upgraded) {
            return { ...s, vendorData: { ...s.vendorData, stock: data.stock, price: data.price } };
          }
          return s;
        });
      setScans(applyUpdate);
      setFilteredScans(applyUpdate);
    });

    // ✨ Un vendeur vient de référencer un barcode repéré en community
    socket.current.on("productLinkedToVendor", (data) => {
      console.log("✨ [CLIENT] productLinkedToVendor reçu:", data);
      if (!data?.barcode) return;
      const applyUpgrade = (prev) =>
        prev.map(s =>
          s.barcode === data.barcode
            ? {
                ...s,
                upgraded: true,
                vendorLink: data.vendorLink || data,
                vendorData: {
                  name:  data.vendorName || null,
                  price: data.price ?? null,
                  stock: data.stock  || null,
                },
              }
            : s
        );
      setScans(applyUpgrade);
      setFilteredScans(applyUpgrade);
      if (canNotifyGlobally) {
        safeToast(() => toast.info(
          `✨ Un vendeur référence maintenant "${data.barcode}"${data.vendorName ? ` chez ${data.vendorName}` : ""}`
        ));
      }
    });

    return () => {
      socket.current.off("statusUpdate");
      socket.current.off("productUpdate");
      socket.current.off("unsubscribeFromRemovedProducts");
      socket.current.off("newScan");
      socket.current.off("vendorLinkUpdated");
      socket.current.off("productLinkedToVendor");
    };
  }, [userId, isSubscribedToPush, productSubscriptions]);

  // Abonnement socket a chaque liste "scans" actualisee (QR + barcode)
  useEffect(() => {
    if (!scans.length) return;
    scans.forEach(s => {
      if (s.productId) socket.current.emit('subscribeToProduct', s.productId);
      if (s.barcode) {
        socket.current.emit('subscribeToBarcode', s.barcode);
        console.log('🔧 [CLIENT subscribeToBarcode] émis: ' + s.barcode);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scans]);

  // ✅ Scanner QR/Barcode — Html5Qrcode + boucle de fallback (même implémentation que BarcodeScanner vendeur)
  useEffect(() => {
    if (!showScanner) return;

    let mounted = true;
    stoppedRef.current = false;
    scanningRef.current = false;

    const CAMERA_CONFIGS = [
      { facingMode: { exact: "environment" } }, // mobile : caméra arrière stricte
      { facingMode: "environment" },             // mobile : caméra arrière relaxée
      {},                                        // desktop / fallback
    ];

    const SCAN_CONFIG = {
      fps: 10,
      qrbox: (w, h) => {
        const size = Math.round(Math.min(w, h) * 0.95);
        return { width: size, height: size };
      },
    };

    const start = async () => {
      await new Promise((res) => setTimeout(res, 350));
      if (!mounted || !document.getElementById("reader")) return;

      const html5QrCode = new Html5Qrcode("reader");
      scannerRef.current = html5QrCode;

      for (const config of CAMERA_CONFIGS) {
        if (!mounted) return;
        try {
          await html5QrCode.start(
            config,
            SCAN_CONFIG,
            (decodedText) => {
              if (scanningRef.current) return;
              scanningRef.current = true;
              safeStop();
              handleScan(decodedText);
              setShowScanner(false);
            }
          );
          return; // succès — on sort de la boucle
        } catch (err) {
          console.warn("[Scanner client] Config échouée :", config, "→", err?.message);
        }
      }

      // Toutes les configs ont échoué
      if (mounted) {
        toast.error("❌ Impossible de démarrer la caméra. Vérifie les permissions.");
        setShowScanner(false);
      }
    };

    start();

    // MutationObserver : traduit les libellés caméra réinjectés par html5-qrcode
    const observer = new MutationObserver(() => {
      const readerEl = document.getElementById("reader");
      if (!readerEl) return;
      const select = readerEl.querySelector("select");
      if (select) {
        Array.from(select.options).forEach(opt => {
          const t = opt.text.toLowerCase();
          if (t.includes("back") || t.includes("environment") || t.includes("arrière")) {
            opt.text = "📷 Caméra arrière";
          } else if (t.includes("front") || t.includes("user") || t.includes("avant")) {
            opt.text = "🤳 Caméra avant";
          }
        });
      }
    });

    const readerEl = document.getElementById("reader");
    if (readerEl) observer.observe(readerEl, { childList: true, subtree: true, characterData: true });

    return () => {
      mounted = false;
      observer.disconnect();
      safeStop();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showScanner]);

  // ─────────────────────────────────────────────────────────────
  // Helper : détermine le type de contenu décodé par le scanner
  //
  // "qr"      → URL CrushNow complète, ou chemin contenant "/"
  // "barcode" → numérique 8-14 chiffres (EAN-8, EAN-13, EAN-14)
  //             ou alphanumérique 4-50 chars sans "/" (CODE128, etc.)
  // "unknown" → trop court, trop long, ou format inattendu
  // ─────────────────────────────────────────────────────────────
  const detectScanType = (raw) => {
    if (!raw || raw.length < 3) return "unknown";

    // QR CrushNow : URL complète ou chemin avec "/"
    if (raw.startsWith("http") || raw.includes("/")) return "qr";

    // EAN-8 / EAN-13 / EAN-14 : uniquement des chiffres, 8 à 14 caractères
    if (/^\d{8,14}$/.test(raw)) return "barcode";

    // CODE128 / autres formats : alphanumérique, longueur raisonnable
    if (/^[a-zA-Z0-9\-. ]{4,50}$/.test(raw)) return "barcode";

    return "unknown";
  };

  // ─────────────────────────────────────────────────────────────
  // Helper : normalise la réponse de scan vers la structure standard.
  //
  // type "vendor"  → produit identifié avec données vendeur (QR ou barcode + VendorProductLink)
  // type "product" → produit identifié mais sans lien vendeur (barcode sans VendorProductLink)
  // ─────────────────────────────────────────────────────────────
  const buildScanResult = (scan) => {
    const product = {
      name:     scan.articleName || "Produit inconnu",
      category: scan.globalProduct?.category || null,
      imageUrl: scan.globalProduct?.imageUrl || null,
      barcode:  scan.barcode || null,
      status:   scan.status  || null,
    };

    // Flux QR : le vendeur est identifié via ownerName (pas de vendorLink)
    if (!scan.barcode) {
      return {
        type: "vendor",
        product,
        vendorData: {
          name:       scan.ownerName || null,
          price:      null,
          stock:      scan.status    || null,
          customNote: null,
        },
      };
    }

    // Flux barcode avec lien vendeur
    if (scan.vendorLink) {
      return {
        type: "vendor",
        product,
        vendorData: {
          name:       scan.ownerName && scan.ownerName !== "Inconnu" ? scan.ownerName : null,
          price:      scan.vendorLink.price      ?? null,
          stock:      scan.vendorLink.stock      || null,
          customNote: scan.vendorLink.customNote || null,
        },
      };
    }

    // Flux barcode sans lien vendeur
    return { type: "product", product, vendorData: null };
  };

  const handleScan = async (text) => {
    if (!text || scanCooldown) return;

    const raw = text.trim();

    // Sanity check : ignorer les chaînes vides ou trop courtes (bruit résiduel)
    if (!raw || raw.length < 3) {
      console.warn("⚠️ [handleScan] Texte scanné trop court, ignoré :", raw);
      return;
    }

    setScanCooldown(true);
    setLastScanResult(null);

    const scanType = detectScanType(raw);
    console.log(`🔍 [handleScan] Type détecté : "${scanType}" — valeur : "${raw}"`);

    // ─── Format non reconnu ───
    if (scanType === "unknown") {
      safeToast(() => toast.warn("⚠️ Format non reconnu. Essayez un QR code ou un code-barres EAN."));
      setTimeout(() => setScanCooldown(false), 3000);
      return;
    }

    // ─── Flux barcode (V2) ───
    if (scanType === "barcode") {
      const barcode = raw;
      console.log("📦 [handleScan] Barcode détecté :", barcode);

      // Upsert : remplace le scan si déjà ajouté par le socket (évite les doublons)
      const upsertScan = (scan) => (prev) => {
        const id = scan._id?.toString();
        const idx = id ? prev.findIndex(s => s._id?.toString() === id) : -1;
        return idx >= 0 ? prev.map((s, i) => i === idx ? scan : s) : [scan, ...prev];
      };

      const doBarcodeScan = async (location = null) => {
        try {
          const payload = { barcode, scanType: "barcode" };
          if (location) payload.location = location;
          const res = await axiosAuth.post(API_URL, payload);
          const scan = res.data?.scan || res.data;
          setScans(upsertScan(scan));
          setFilteredScans(upsertScan(scan));
          setLastScanResult(buildScanResult(scan));
          safeToast(() => toast.success(`📦 ${scan?.articleName || barcode} scanné !`));
          navigator.vibrate?.(50);
          setScanFlash(true);
          setTimeout(() => setScanFlash(false), 400);
        } catch (err) {
          if (err.response?.status === 404) {
            setLastScanResult({ type: "unknown", product: null, vendorData: null, barcode });
            safeToast(() => toast.warn("⚠️ Produit non encore référencé."));
          } else if (err.response?.status === 429) {
            safeToast(() => toast.info("⏱️ Ce code-barres a déjà été scanné récemment."));
          } else {
            safeToast(() => toast.error("❌ Erreur lors du scan barcode."));
          }
        } finally {
          setTimeout(() => setScanCooldown(false), 5000);
        }
      };

      if (geolocEnabled) {
        navigator.geolocation.getCurrentPosition(
          (pos) => doBarcodeScan({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
          () => doBarcodeScan(),
          { timeout: 15000, enableHighAccuracy: false, maximumAge: 60000 }
        );
      } else {
        await doBarcodeScan();
      }
      return; // ← ne pas tomber dans le flux QR
    }

    // ─── Flux QR (existant) — comportement inchangé ───
    // scanType === "qr" garanti ici
    const productId = raw.split("?")[0].split("/").pop();

    // Sanity check : productId ne doit pas être vide après extraction
    if (!productId) {
      safeToast(() => toast.error("❌ QR code invalide : impossible d'extraire l'identifiant produit."));
      setTimeout(() => setScanCooldown(false), 3000);
      return;
    }

    if (geolocEnabled) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          try {
            const res = await axiosAuth.post(API_URL, {
              productId,
              location: {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
              },
            });

            const scan = res.data?.scan || res.data;
            setScans(prev => [scan, ...prev]);
            setLastScanResult(buildScanResult(scan));
            safeToast(() => toast.success(`📍 ${scan?.articleName} scanné avec localisation !`));
          } catch (err) {
            safeToast(() => toast.error("❌ Erreur lors du scan avec géolocalisation."));
          } finally {
            setTimeout(() => setScanCooldown(false), 5000);
          }
        },
        async () => {
          try {
            const res = await axiosAuth.post(API_URL, { productId });
            const scan = res.data?.scan || res.data;
            setScans(prev => [scan, ...prev]);
            setLastScanResult(buildScanResult(scan));
            safeToast(() => toast.info(`📄 Scan enregistré sans position.`));
          } catch (err) {
            logger.error('ClientHistory', 'Erreur scan QR avec geoloc', { message: err?.message, status: err?.response?.status, responseData: err?.response?.data });
            safeToast(() => toast.error("❌ Erreur lors du scan."));
          } finally {
            setTimeout(() => setScanCooldown(false), 5000);
          }
        },
        { timeout: 15000, enableHighAccuracy: false, maximumAge: 60000 }
      );
    } else {
      try {
        const res = await axiosAuth.post(API_URL, { productId });
        const scan = res.data?.scan || res.data;
        setScans(prev => [scan, ...prev]);
        setLastScanResult(buildScanResult(scan));
        safeToast(() => toast.success(`📄 ${scan?.articleName} scanné !`));
      } catch (err) {
        logger.error('ClientHistory', 'Erreur scan QR sans geoloc', { message: err?.message, status: err?.response?.status, responseData: err?.response?.data });
        safeToast(() => toast.error("❌ Erreur lors du scan."));
      } finally {
        setTimeout(() => setScanCooldown(false), 5000);
      }
    }
  };

  // ✅ Activer/Désactiver notifications générales (FCM)
  const saveFcmTokenToBackend = async (fcmToken) => {
    await axiosAuth.post("/push/save-fcm-token", {
      userId: user?._id || user?.id,
      fcmToken,
    });
    localStorage.setItem("fcm_token", fcmToken);
    const updatedUser = { ...user, subscribedToPush: true };
    localStorage.setItem("user", JSON.stringify(updatedUser));
    setIsSubscribedToPush(true);
    safeToast(() => toast.success("🔔 Notifications activées !"));
  };

  const togglePushSubscription = async () => {
    console.log("🧭 [togglePushSubscription] — Début, plateforme :", Capacitor.getPlatform());
    try {
      const newStatus = !isSubscribedToPush;
      console.log("📌 Nouvel état souhaité :", newStatus ? "Activer" : "Désactiver");

      // ── DÉSACTIVATION ────────────────────────────────────────────
      if (!newStatus) {
        const storedToken = localStorage.getItem("fcm_token");
        try {
          if (storedToken && messaging) await deleteToken(messaging);
        } catch (err) {
          console.warn("⚠️ deleteToken :", err?.message);
        }
        await axiosAuth.post("/push/save-fcm-token", {
          userId: user?._id || user?.id,
          fcmToken: null,
        });
        localStorage.removeItem("fcm_token");
        const updatedUser = { ...user, subscribedToPush: false };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        setIsSubscribedToPush(false);
        safeToast(() => toast.info("🔕 Notifications désactivées."));
        return;
      }

      // ── ACTIVATION — CAPACITOR NATIF (Android / iOS) ─────────────
      if (Capacitor.isNativePlatform()) {
        console.log("📱 [FCM] Plateforme native — utilisation PushNotifications Capacitor");

        const permResult = await PushNotifications.requestPermissions();
        console.log("📜 [FCM] Permission Capacitor :", permResult.receive);

        if (permResult.receive !== "granted") {
          console.warn("⚠️ [FCM] Permission native refusée");
          safeToast(() => toast.warn("⚠️ Permission de notification refusée."));
          return;
        }

        // Enregistrement unique : on retire les anciens listeners avant d’en ajouter
        await PushNotifications.removeAllListeners();

        await new Promise((resolve, reject) => {
          PushNotifications.addListener("registration", async (token) => {
            console.log("🎫 [FCM] Token natif reçu :", token.value.slice(0, 20) + "...");
            try {
              await saveFcmTokenToBackend(token.value);
              resolve();
            } catch (err) {
              reject(err);
            }
          });

          PushNotifications.addListener("registrationError", (err) => {
            console.error("❌ [FCM] Erreur enregistrement natif :", err);
            setIsSubscribedToPush(false);
            safeToast(() => toast.error("❌ Erreur d’enregistrement des notifications."));
            reject(new Error(err?.error || "registrationError"));
          });

          PushNotifications.register();
        });

        return;
      }

      // ── ACTIVATION — FALLBACK WEB (navigateur desktop) ──────────
      console.log("🌐 [FCM] Plateforme web — utilisation Notification API");

      if (typeof Notification === "undefined") {
        console.warn("⚠️ [FCM] Notification API absente");
        safeToast(() => toast.error("❌ Les notifications push ne sont pas supportées sur ce navigateur."));
        return;
      }

      const permission = await Notification.requestPermission();
      console.log("📜 [FCM] Permission web :", permission);

      if (permission !== "granted") {
        safeToast(() => toast.warn("⚠️ Permission de notification refusée."));
        return;
      }

      const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      console.log("✅ [FCM] SW enregistré :", registration.scope);

      const vapidKey =
        process.env.REACT_APP_PUBLIC_VAPID_KEY ||
        "BBGKXZTNZYudlq-1Byuovg-i0ikbgmZBd12ZeIYMsHA8I0lbIfOo7UrVjUInsgkdnKdBwXzcjie8ke1-Rp8KICY";

      let fcmToken;
      try {
        fcmToken = await getToken(messaging, { vapidKey, serviceWorkerRegistration: registration });
        console.log("🎫 [FCM] Token web :", fcmToken ? fcmToken.slice(0, 20) + "..." : "null");
      } catch (tokenErr) {
        console.error("❌ [FCM] getToken erreur :", tokenErr?.message);
        safeToast(() => toast.error("❌ Erreur lors de la génération du token FCM."));
        return;
      }

      if (!fcmToken) {
        safeToast(() => toast.error("❌ Impossible de générer un token FCM."));
        return;
      }

      await saveFcmTokenToBackend(fcmToken);

    } catch (err) {
      console.error("❌ [FCM] Erreur togglePushSubscription :", err?.message, err);
      safeToast(() => toast.error("Erreur lors de la mise à jour des notifications."));
    }
  };

  // ✅ Alerte / Stop par produit
  const toggleProductSubscription = async (productId, hasVendor = false) => {
    console.log("🚀 [ALERTE] Appel toggleProductSubscription :", { userId, productId, typeUserId: typeof userId, typeProductId: typeof productId });
    const current = !!productSubscriptions[productId];
    try {
      setProductSubscriptions(prev => ({ ...prev, [productId]: !current }));

      if (!current) {
        const res = await axiosAuth.put(
          "/push/subscribe-product",
          { userId, productId, subscribe: true }
        );
        console.log("✅ [ALERTE] Réponse subscribe-product :", res.data);
        safeToast(() => toast.success("🔔 Alerte activée !"));
      } else {
        await axiosAuth.post(
          "/push/unsubscribe-product",
          { productId }
        );
        safeToast(() => toast.info("🔕 Alerte désactivée."));
      }
    } catch (err) {
      console.error("❌ [ALERTE] Erreur appel API :", err?.response?.status, err?.response?.data, err?.message);
      setProductSubscriptions(prev => ({ ...prev, [productId]: current }));
      safeToast(() => toast.error("❌ Impossible de changer l’abonnement produit."));
    }
  };

  // ✅ Vider l’historique
  const clearHistory = async () => {
    if (!window.confirm("❗ Es-tu sûr(e) de vouloir supprimer tout l'historique ?")) return;
    try {
      const res = await axiosAuth.delete(`/scans/clear/${userId}`);
      safeToast(() => toast.success(`🧹 ${res.data.deletedCount} scan(s) supprimé(s)`));
      setScans([]);
      setFilteredScans([]);
      _scansCache = [];
    } catch (err) {
      logger.error('ClientHistory', 'Erreur clearHistory', { message: err?.message, status: err?.response?.status });
      safeToast(() => toast.error("❌ Erreur côté client."));
    }
  };

  const deleteAccount = () => {
    trackAction("Supprimer mon compte");
    setDeletePassword("");
    setDeleteSeedPhrase("");
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    const isPseudo = !user?.email;
    setDeleteLoading(true);
    try {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const body = isPseudo
        ? { seed: deleteSeedPhrase.trim().split(/\s+/) }
        : { password: deletePassword };
      await axios.delete("/api/auth/delete-account", {
        headers: { Authorization: `Bearer ${storedUser?.token}` },
        data: body
      });
      localStorage.clear();
      window.location.href = "/";
    } catch (err) {
      logger.error('ClientHistory', 'Erreur deleteAccount', { message: err?.message, status: err?.response?.status, responseData: err?.response?.data });
      safeToast(() => toast.error("❌ Confirmation incorrecte ou impossible de supprimer le compte."));
    } finally {
      setDeleteLoading(false);
    }
  };

  // ✅ Supprimer un scan
    const deleteScan = async (scan) => {
      const name = scan.articleName || "cet article";
      if (!window.confirm(`❗ Supprimer le scan du produit : "${name}" ?`)) return;
      const scanId = scan._id;
    try {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const res = await axios.delete(`/api/scans/${scanId}`, {
        headers: { Authorization: `Bearer ${storedUser?.token}` }
      });
      if (res.status === 200) {
        safeToast(() => toast.success("✅ Scan supprimé !"));
        setScans(prev => prev.filter(s => s._id !== scanId));
        setFilteredScans(prev => prev.filter(s => s._id !== scanId));
        if (_scansCache) _scansCache = _scansCache.filter(s => s._id !== scanId);
      }
    } catch (err) {
      logger.error('ClientHistory', 'Erreur deleteScan', { message: err?.message, status: err?.response?.status, scanId });
      safeToast(() => toast.error("❌ Erreur lors de la suppression"));
    }
  };

  const markAsPurchased = async (scanId) => {
    try {
      const res = await axiosAuth.patch(`/scans/${scanId}/purchase`);
      const updated = res.data?.scan;
      // Marque le scan acheté EN PLACE au lieu de le retirer : c'est déjà son
      // état après rechargement (badge "Acheté ✓"), et le retirer le faisait
      // disparaître de l'onglet "Mes achats" (qui lit le même state) jusqu'au
      // prochain refetch — _scansCache compris, sinon il ressuscite sans achat
      const apply = (list) => list.map(s =>
        s._id === scanId
          ? { ...s, purchased_at: updated?.purchased_at || new Date().toISOString(), purchase_delay_hours: updated?.purchase_delay_hours ?? null }
          : s
      );
      setScans(apply);
      setFilteredScans(apply);
      if (_scansCache) _scansCache = apply(_scansCache);
      safeToast(() => toast.success("✓ Achat enregistré — retrouve-le dans « Mes achats »"));
    } catch (err) {
      safeToast(() => toast.error("❌ Erreur lors de l'enregistrement de l'achat"));
    }
  };

  // ✅ Annuler un achat — remet le scan dans les crushs (même pattern en place)
  const unmarkAsPurchased = async (scanId) => {
    try {
      await axiosAuth.patch(`/scans/${scanId}/unpurchase`);
      const apply = (list) => list.map(s =>
        s._id === scanId ? { ...s, purchased_at: null, purchase_delay_hours: null } : s
      );
      setScans(apply);
      setFilteredScans(apply);
      if (_scansCache) _scansCache = apply(_scansCache);
      safeToast(() => toast.success("↩️ Remis dans tes crushs !"));
    } catch (err) {
      safeToast(() => toast.error("❌ Erreur lors de l'annulation de l'achat"));
    }
  };

  // ✅ Ajouter un crush depuis un lien externe (URL produit)
  const closeAddLink = () => {
    setShowAddLink(false);
    setAddLinkUrl("");
    setAddLinkTitle("");
    setAddLinkNeedsTitle(false);
    setAddLinkError(null);
    setAddLinkLoading(false);
  };

  const submitAddLink = async () => {
    const url = addLinkUrl.trim();
    if (!url) {
      setAddLinkError("Colle d'abord le lien de l'article.");
      return;
    }
    setAddLinkLoading(true);
    setAddLinkError(null);
    try {
      const body = addLinkNeedsTitle && addLinkTitle.trim()
        ? { url, manual_title: addLinkTitle.trim() }
        : { url };
      const res = await axiosAuth.post(`${API_URL}/crush/from-url`, body);
      const newScan = res.data?.scan;
      if (newScan) {
        setScans(prev => [newScan, ...prev]);
        setFilteredScans(prev => [newScan, ...prev]);
        if (_scansCache) _scansCache = [newScan, ..._scansCache];
      }
      safeToast(() => toast.success("🔗 Crush ajouté depuis le lien !"));
      closeAddLink();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 422) {
        setAddLinkNeedsTitle(true);
        setAddLinkError("Impossible de lire cette page — ajoute le titre de l'article pour l'enregistrer quand même.");
      } else if (status === 400) {
        setAddLinkError(err?.response?.data?.error || "URL invalide — vérifie le lien.");
      } else if (status === 429) {
        setAddLinkError("Trop d'ajouts de liens — réessaie dans quelques minutes.");
      } else {
        setAddLinkError("Erreur lors de l'ajout du lien. Réessaie.");
      }
    } finally {
      setAddLinkLoading(false);
    }
  };

  const handleLogout = async (actionName) => {
    if (actionName) trackAction(actionName);
    const fcmToken = localStorage.getItem("fcm_token");
    try { await axiosAuth.post("/auth/logout", { fcmToken }); } catch { /* best-effort */ }
    localStorage.removeItem("user");
    localStorage.removeItem("fcm_token");
    window.location.href = "/login";
  };


  if (!user) return null;

  if (loading) return (
    <div style={{ minHeight: "100vh", background: "var(--crush-pink)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "14px" }}>
      <div className="ch-spinner" />
      <p style={{ color: "white", fontSize: "14px", fontWeight: 500 }}>Chargement...</p>
    </div>
  );

  // ── Métriques d'affichage (calculées depuis les données existantes) ──
  const totalScans = scans.length;
  const uniqueCities = [...new Set(scans.map(s => s.city).filter(Boolean))];
  const enStockCount = scans.filter(s => {
    if (s.source === "url") return false; // pas de donnée de stock sur les liens externes
    const st = (s.scanType === "barcode" && s.vendorLink?.stock) ? s.vendorLink.stock : s.status;
    return st === "en stock";
  }).length;
  const initials = (user.name || "U").split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase();

  // ── Filtre d'AFFICHAGE : les achetés sont masqués de l'onglet Crushs mais
  // restent entiers dans scans/filteredScans/_scansCache (ils alimentent
  // l'onglet Achats). Ne jamais les retirer des données : au refetch ils
  // reviendraient (cf. commit ca20cd4) — seule la vue filtre.
  const notPurchased = (s) => !s.purchased_at;
  const activeCrushes = scans.filter(notPurchased);
  const visibleCrushes = filteredScans.filter(notPurchased);

  // Filtres chips (onglet Scans) — dérivés des crushs actifs uniquement
  // (les achetés sont masqués de cet onglet)
  const cityChips = [...new Set(activeCrushes.map(s => s.city).filter(Boolean))];
  // "Site" n'apparaît que si l'utilisateur a au moins un crush lien externe
  // (même logique dynamique que les villes)
  const hasUrlCrushes = activeCrushes.some(s => s.source === "url");
  const ALL_FILTERS = ["Tous", "En stock", "En promo", "Indisponible", "En attente", ...(hasUrlCrushes ? ["Site"] : []), ...cityChips];

  // Les crushes lien externe n'ont aucune donnée vendeur : exclus des filtres
  // de stock (les anciens documents URL portent encore le default "en stock")
  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    if (filter === "Tous") {
      setFilteredScans(scans);
    } else if (filter === "En stock") {
      setFilteredScans(scans.filter(s => {
        if (s.source === "url") return false;
        const st = (s.scanType === "barcode" && s.vendorLink?.stock) ? s.vendorLink.stock : s.status;
        return st === "en stock";
      }));
    } else if (filter === "En promo") {
      setFilteredScans(scans.filter(s => {
        if (s.source === "url") return false;
        const st = (s.scanType === "barcode" && s.vendorLink?.stock) ? s.vendorLink.stock : s.status;
        return st === "promotion";
      }));
    } else if (filter === "Indisponible") {
      setFilteredScans(scans.filter(s => {
        if (s.source === "url") return false;
        const st = (s.scanType === "barcode" && s.vendorLink?.stock) ? s.vendorLink.stock : s.status;
        return st === "indisponible";
      }));
    } else if (filter === "En attente") {
      setFilteredScans(scans.filter(s => s.scanType === "barcode" && !s.vendorLink));
    } else if (filter === "Site") {
      setFilteredScans(scans.filter(s => s.source === "url"));
    } else {
      setFilteredScans(scans.filter(s => s.city === filter));
    }
  };

  const getStatusInfo = (scan) => {
    const st = (scan.scanType === "barcode" && scan.vendorLink?.stock) ? scan.vendorLink.stock : scan.status;
    if (st === "promotion")   return { cls: "ch-status-pill promo",   label: "Promotion" };
    if (st === "indisponible") return { cls: "ch-status-pill indispo", label: "Indisponible" };
    if (st === "en stock")    return { cls: "ch-status-pill stock",   label: "En stock" };
    return { cls: "ch-status-pill pending", label: st || "En attente" };
  };

  // Positions pour la carte
  const mapPositions = scans.map(scan => {
    const lat = scan.product?.location?.lat || scan.location?.lat || null;
    const lng = scan.product?.location?.lng || scan.location?.lng || null;
    if (lat === null || lng === null) return null;
    return { ...scan, position: [lat, lng] };
  }).filter(Boolean);
  const defaultMapCenter = [4.933, -52.33];

  // Icône de scan selon le type
  const scanIcon = (type) => type === "community" ? "📝" : type === "barcode" ? "📦" : type === "url" ? "🔗" : "🎯";

  return (
    <div className="ch-wrapper">
      {scanFlash && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 9999,
          background: "rgba(22, 163, 74, 0.3)",
          animation: "scanSuccessFade 400ms ease-out forwards",
          pointerEvents: "none",
        }} />
      )}
      <style>{`@keyframes scanSuccessFade { 0% { opacity: 1; } 100% { opacity: 0; } }`}</style>

      {showHelp && <ClientHelpModal onClose={() => setShowHelp(false)} />}

      {/* ══ MODAL AJOUT CRUSH DEPUIS UN LIEN ══ */}
      {showAddLink && (
        <div className="ch-overlay" onClick={addLinkLoading ? undefined : closeAddLink}>
          <div className="ch-overlay-panel" style={{ maxWidth: "360px" }} onClick={(e) => e.stopPropagation()}>
            <p style={{ fontSize: "15px", fontWeight: 700, color: "#0f172a", marginBottom: "8px" }}>
              🔗 Ajouter un crush depuis un lien
            </p>
            <p style={{ fontSize: "12px", color: "#475569", marginBottom: "14px", lineHeight: 1.6 }}>
              Colle le lien d'une page produit (ex : Kiabi, Zara…) — on récupère le titre et l'image pour toi.
            </p>
            <input
              type="url"
              inputMode="url"
              autoFocus
              placeholder="https://www.kiabi.fr/…"
              value={addLinkUrl}
              onChange={(e) => setAddLinkUrl(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") submitAddLink(); }}
              disabled={addLinkLoading}
              style={{ width: "100%", padding: "12px", borderRadius: "10px", border: "1px solid #E2E8F0", fontSize: "14px", boxSizing: "border-box" }}
            />
            {addLinkNeedsTitle && (
              <input
                type="text"
                placeholder="Titre de l'article"
                maxLength={200}
                value={addLinkTitle}
                onChange={(e) => setAddLinkTitle(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") submitAddLink(); }}
                disabled={addLinkLoading}
                style={{ width: "100%", padding: "12px", borderRadius: "10px", border: "1px solid #E2E8F0", fontSize: "14px", marginTop: "8px", boxSizing: "border-box" }}
              />
            )}
            {addLinkError && (
              <p style={{ fontSize: "12px", color: "#DC2626", margin: "10px 0 0", lineHeight: 1.5 }}>{addLinkError}</p>
            )}
            <button
              onClick={submitAddLink}
              disabled={addLinkLoading || !addLinkUrl.trim() || (addLinkNeedsTitle && !addLinkTitle.trim())}
              style={{
                width: "100%", marginTop: "14px", padding: "13px",
                background: addLinkLoading ? "#F9A8D4" : "linear-gradient(135deg, #D41A6E, #E87010)",
                color: "white", border: "none", borderRadius: "13px",
                fontWeight: 700, fontSize: "14px",
                cursor: addLinkLoading ? "wait" : "pointer",
                opacity: (!addLinkUrl.trim() || (addLinkNeedsTitle && !addLinkTitle.trim())) ? 0.6 : 1,
                touchAction: "manipulation",
              }}
            >
              {addLinkLoading ? "Récupération de la page…" : "Ajouter"}
            </button>
            <button
              onClick={closeAddLink}
              disabled={addLinkLoading}
              style={{ width: "100%", marginTop: "8px", padding: "11px", background: "#F1F5F9", color: "#475569", border: "none", borderRadius: "13px", fontWeight: 600, fontSize: "13px", cursor: "pointer", touchAction: "manipulation" }}
            >
              Annuler
            </button>
          </div>
        </div>
      )}

      {/* ══ MODAL SUPPRESSION COMPTE ══ */}
      {showDeleteModal && (
        <div className="ch-overlay">
          <div className="ch-overlay-panel" style={{ maxWidth: "360px" }}>
            <p style={{ fontSize: "15px", fontWeight: 700, color: "#dc2626", marginBottom: "8px" }}>
              🗑️ Supprimer mon compte
            </p>
            <p style={{ fontSize: "12px", color: "#475569", marginBottom: "16px", lineHeight: 1.6 }}>
              Cette action est irreversible. Toutes vos donnees seront effacees.
            </p>
            {!user?.email ? (
              <>
                <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "6px" }}>
                  Tes 12 mots de recuperation
                </label>
                <textarea
                  value={deleteSeedPhrase}
                  onChange={(e) => setDeleteSeedPhrase(e.target.value)}
                  placeholder="mot1 mot2 mot3 ... mot12"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                  rows={3}
                  style={{
                    width: "100%", padding: "10px 12px", border: "1.5px solid #CBD5E1",
                    borderRadius: "8px", fontSize: "13px", background: "#F8FAFC",
                    color: "#1e293b", boxSizing: "border-box", resize: "vertical",
                    fontFamily: "inherit", lineHeight: 1.6, marginBottom: "12px", display: "block"
                  }}
                />
              </>
            ) : (
              <>
                <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "6px" }}>
                  Mot de passe
                </label>
                <input
                  type="password"
                  value={deletePassword}
                  onChange={(e) => setDeletePassword(e.target.value)}
                  placeholder="Votre mot de passe"
                  style={{
                    width: "100%", padding: "10px 12px", border: "1.5px solid #CBD5E1",
                    borderRadius: "8px", fontSize: "13px", background: "#F8FAFC",
                    color: "#1e293b", boxSizing: "border-box", marginBottom: "12px", display: "block"
                  }}
                />
              </>
            )}
            <button
              onClick={handleDeleteConfirm}
              disabled={deleteLoading}
              style={{
                width: "100%", padding: "11px", background: "#dc2626", color: "white",
                border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: 700,
                cursor: "pointer", marginBottom: "8px"
              }}
            >
              {deleteLoading ? "Suppression..." : "Supprimer definitivement"}
            </button>
            <button
              onClick={() => setShowDeleteModal(false)}
              style={{
                width: "100%", padding: "11px", background: "#f1f5f9", color: "#475569",
                border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: 600,
                cursor: "pointer"
              }}
            >
              Annuler
            </button>
          </div>
        </div>
      )}

      {/* ══ HEADER ══ */}
      <header className="ch-header">
        <div className="ch-header-top">
          <div>
            <span className="ch-greeting">Bonjour,</span>
            <h1 className="ch-username">{editNameValue || user.name}</h1>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <button
              className="ch-logout-header"
              onClick={() => handleLogout("Deconnexion header")}
            >
              Déconnexion
            </button>
            <button className="ch-help-btn" onClick={() => setShowHelp(true)} title="Aide">❓</button>
            <button
              className="ch-avatar ch-avatar-btn"
              onClick={() => setActiveTab("profil")}
              title="Mon profil"
            >
              {(editNameValue || user.name || "U").split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}
            </button>
          </div>
        </div>
        <div className="ch-stats">
          <div className="ch-stat-pill">
            <span className="ch-stat-num">{totalScans}</span>
            <span className="ch-stat-lbl">Scans</span>
          </div>
          <div className="ch-stat-pill">
            <span className="ch-stat-num">{uniqueCities.length}</span>
            <span className="ch-stat-lbl">Villes</span>
          </div>
          <div className="ch-stat-pill">
            <span className="ch-stat-num">{enStockCount}</span>
            <span className="ch-stat-lbl">En stock</span>
          </div>
        </div>
      </header>

      {/* ══ SCANNER OVERLAY ══ */}
      {showScanner && (
        <div className="ch-scanner-overlay">
          <button className="ch-scanner-close" onClick={() => setShowScanner(false)}>✕</button>
          <p className="ch-scanner-title">POSITIONNEZ LE CODE DANS LE CADRE</p>
          <p className="ch-scanner-subtitle">LE CODE DOIT ÊTRE BIEN VISIBLE ET CENTRÉ</p>
          <div className="ch-scanner-frame-wrapper">
            <div ref={readerRef} id="reader" style={{ minHeight: "380px" }} />
            <div className="ch-scanner-corners" aria-hidden="true">
              <span className="ch-corner ch-corner-tl" />
              <span className="ch-corner ch-corner-tr" />
              <span className="ch-corner ch-corner-bl" />
              <span className="ch-corner ch-corner-br" />
              <span className="ch-reticle-h" />
              <span className="ch-reticle-v" />
            </div>
          </div>
        </div>
      )}

      {/* ══ PRODUIT RÉFÉRENCÉ — SÉLECTION MAGASIN ══ */}
      {(lastScanResult?.type === "vendor" || lastScanResult?.type === "product") && (
        <div className="ch-overlay">
          <div className="ch-overlay-panel">
            <p style={{ fontSize: "13px", fontWeight: 700, color: "#16a34a", marginBottom: "6px" }}>
              ✅ {lastScanResult.product?.name || "Produit scanné"}
            </p>
            <p style={{ fontSize: "12px", color: "#475569", marginBottom: "12px" }}>
              Dans quel magasin êtes-vous ?
            </p>
            <StoreAutocomplete
              value={scanStore}
              onChange={(v) => setScanStore(v)}
              lat={scans[0]?.location?.lat}
              lng={scans[0]?.location?.lng}
              disabled={false}
              inputStyle={{
                width: "100%", padding: "9px 12px", borderRadius: "8px",
                border: "1.5px solid #CBD5E1", fontSize: "0.875rem",
                background: "#F8FAFC", color: "#1e293b",
                boxSizing: "border-box", display: "block"
              }}
            />
            <div style={{ marginBottom: "10px" }}>
              <label style={{ fontSize: "12px", color: "#475569", display: "block", marginBottom: "4px" }}>
                💰 Prix observé (optionnel)
                {scans[0]?.price && scans[0]?.price_source === "open_prices" && (
                  <span style={{ fontSize: "11px", color: "#94a3b8", marginLeft: "6px" }}>
                    *Open Prices suggère {scans[0].price}€
                  </span>
                )}
              </label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={scanPrice}
                onChange={(e) => setScanPrice(e.target.value)}
                placeholder={scans[0]?.price ? `${scans[0].price}€ (Open Prices)` : "Ex: 4,50"}
                style={{
                  width: "100%", padding: "9px 12px", borderRadius: "8px",
                  border: "1.5px solid #CBD5E1", fontSize: "0.875rem",
                  background: "#F8FAFC", color: "#1e293b",
                  boxSizing: "border-box", display: "block"
                }}
              />
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                onClick={() => {
                  if (scanStore) {
                    const lastScan = scans[0];
                    if (lastScan?._id) updateScanStore(lastScan._id, scanStore);
                  } else {
                    setLastScanResult(null);
                  }
                }}
                style={{
                  flex: 1, padding: "10px", borderRadius: "8px", border: "none",
                  background: "#16a34a", color: "white", fontWeight: 700,
                  fontSize: "0.875rem", cursor: "pointer"
                }}
              >
                {scanStore ? "✅ Enregistrer" : "Passer"}
              </button>
              <button
                onClick={() => { setLastScanResult(null); setScanStore(""); }}
                style={{
                  padding: "10px 14px", borderRadius: "8px", border: "none",
                  background: "#F1F5F9", color: "#475569", fontWeight: 600,
                  fontSize: "0.875rem", cursor: "pointer"
                }}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══ BARCODE INCONNU — BOTTOM SHEET ══ */}
      {lastScanResult?.type === "unknown" && (
        <div className="ch-overlay">
          <div className="ch-overlay-panel">
            <p style={{ fontSize: "11px", fontWeight: 700, color: "#D97706", textTransform: "uppercase", marginBottom: "8px" }}>
              ⚠️ Produit non référencé
            </p>
            <p style={{ fontSize: "14px", color: "#0F172A", marginBottom: "14px" }}>
              Le code-barres{" "}
              <span style={{ fontFamily: "monospace", fontWeight: 700 }}>{lastScanResult.barcode}</span>{" "}
              n'existe dans aucune base connue.
            </p>

            {!showCommunityForm ? (
              <button
                onClick={() => setShowCommunityForm(true)}
                style={{ display: "flex", alignItems: "center", gap: "6px", padding: "10px 16px", background: "#16a34a", color: "white", border: "none", borderRadius: "10px", cursor: "pointer", fontWeight: 700, fontSize: "14px", marginBottom: "10px" }}
              >
                📝 Ajouter ce produit à ma liste
              </button>
            ) : (
              <CommunityProductForm
                barcode={lastScanResult.barcode}
                userId={user?._id || user?.id}
                geolocEnabled={geolocEnabled}
                onSuccess={(scan) => {
                  const upsert = (prev) => {
                    const id = scan._id?.toString();
                    const idx = id ? prev.findIndex(s => s._id?.toString() === id) : -1;
                    return idx >= 0 ? prev.map((s, i) => i === idx ? scan : s) : [scan, ...prev];
                  };
                  setScans(upsert);
                  setFilteredScans(upsert);
                  setLastScanResult(null);
                  setShowCommunityForm(false);
                  safeToast(() => toast.success("📝 Produit ajouté à votre liste !"));
                }}
                onCancel={() => setShowCommunityForm(false)}
              />
            )}

            {user?.role === "vendeur" && (
              <button
                onClick={() => navigate(`/dashboard?barcode=${lastScanResult.barcode}`)}
                style={{ display: "block", padding: "10px 16px", background: "#4F46E5", color: "white", border: "none", borderRadius: "10px", cursor: "pointer", fontWeight: 600, fontSize: "13px", marginBottom: "10px" }}
              >
                ➕ Ajouter à mon catalogue
              </button>
            )}

            <button
              onClick={() => { setLastScanResult(null); setShowCommunityForm(false); }}
              style={{ background: "none", border: "none", color: "#94A3B8", fontSize: "12px", cursor: "pointer", textDecoration: "underline", marginTop: "6px" }}
            >
              Fermer
            </button>
          </div>
        </div>
      )}

      {/* ══ CONTENU TABS ══ */}
      <main className="ch-content">

        {/* ────────── TAB : ACCUEIL ────────── */}
        {activeTab === "accueil" && (
          <>
            {/* CTA Scanner */}
            <button className="ch-scan-cta" onClick={() => { trackAction("Scanner"); setShowScanner(true); }}>
              <div className="ch-scan-cta-icon">📷</div>
              <div style={{ flex: 1 }}>
                <span className="ch-scan-cta-t1">Crush un article</span>
                <span className="ch-scan-cta-t2">Scanne pour mémoriser tes articles préférés</span>
              </div>
              <span style={{ color: "rgba(255,255,255,0.7)", fontSize: "18px" }}>›</span>
            </button>

            <UXHint
              id="client_accueil"
              text="Crush un article = scanne son code QR ou son code-barres pour le mémoriser, suivre son statut et être alerté des changements."
            />

            {/* Tes crushs récents — achetés masqués, comme l'onglet Crushs */}
            {activeCrushes.length > 0 && (
              <>
                <div className="ch-section-header">
                  <span className="ch-section-title">Tes crushs récents</span>
                  <button className="ch-see-all" onClick={() => setActiveTab("scans")}>Voir tout</button>
                </div>
                <div className="ch-scan-list-dark">
                  {activeCrushes.slice(0, 3).map((scan, i) => {
                    const { cls, label } = getStatusInfo(scan);
                    return (
                      <div key={i} className="ch-scan-row-dark">
                        <div className="ch-scan-icon">{scanIcon(scan.scanType)}</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div className="ch-scan-name-dark">{scan.articleName || "Article inconnu"}</div>
                          <div className="ch-scan-meta-dark">
                            {scan.date ? new Date(scan.date).toLocaleDateString("fr-FR") : "—"}
                            {scan.city ? ` · ${scan.city}` : ""}
                          </div>
                          {scan.location_label && (
                            <span className="ch-scan-city">
                              {scan.source === "url" ? "🔗" : "🏪"} {scan.location_label}
                            </span>
                          )}
                          {scan.price && (
                            <span className="ch-scan-city">
                              💰 {scan.price}€
                              {scan.price_source === "open_prices" && (
                                <span style={{ fontSize: "10px", color: "#94a3b8", marginLeft: "4px" }}>
                                  *Open Prices
                                </span>
                              )}
                            </span>
                          )}
                        </div>
                        {/* Pas de badge de statut sur les crushes lien externe */}
                        {scan.source !== "url" && <span className={cls}>{label}</span>}
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {/* Mini carte */}
            <div className="ch-section-header">
              <span className="ch-section-title">Ma carte</span>
              <button className="ch-see-all" onClick={() => setActiveTab("carte")}>Ouvrir</button>
            </div>
            <button
              className="ch-card"
              style={{ width: "100%", cursor: "pointer", textAlign: "left", border: "none" }}
              onClick={() => setActiveTab("carte")}
            >
              <div className="ch-mini-map">
                <div className="ch-mini-map-grid" />
                <span style={{ fontSize: "26px", position: "relative", zIndex: 1 }}>📍</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A" }}>Voir mes points</div>
                  <div style={{ fontSize: "11px", color: "#94A3B8" }}>
                    {mapPositions.length} emplacement{mapPositions.length !== 1 ? "s" : ""} enregistré{mapPositions.length !== 1 ? "s" : ""}
                  </div>
                </div>
                <span style={{ color: "#94A3B8", fontSize: "20px" }}>›</span>
              </div>
            </button>
          </>
        )}

        {/* ────────── TAB : SCANS ────────── */}
        {activeTab === "scans" && (
          <div>
            <UXHint
              id="client_scans"
              text="Retrouve ici tous les articles que tu as crushés. Filtre par statut ou ville pour retrouver rapidement un produit."
            />
            <div className="ch-section-header" style={{ marginBottom: "8px" }}>
              <span className="ch-section-title">Mes crushs produits</span>
              {(() => { const n = scans.filter(s => s.purchased_at).length; return n > 0 ? (
                <span style={{ fontSize: "12px", color: "#64748b", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: "20px", padding: "2px 10px", fontWeight: 600 }}>
                  {n} acheté{n > 1 ? "s" : ""} via CrushNow
                </span>
              ) : null; })()}
            </div>
            {/* Filtres chips */}
            <div className="ch-filters">
              {ALL_FILTERS.map(f => (
                <button
                  key={f}
                  className={`ch-filter-chip ${activeFilter === f ? "active" : ""}`}
                  onClick={() => handleFilterChange(f)}
                >
                  {f}
                </button>
              ))}
            </div>

            {/* Ajout d'un crush depuis un lien externe */}
            <button
              onClick={() => setShowAddLink(true)}
              style={{
                width: "100%", padding: "12px", margin: "4px 0 12px",
                background: "linear-gradient(135deg, #D41A6E, #E87010)",
                color: "white", border: "none", borderRadius: "13px",
                fontWeight: 700, fontSize: "14px", cursor: "pointer",
                touchAction: "manipulation",
              }}
            >
              🔗 + Ajouter un lien
            </button>

            {visibleCrushes.length === 0 ? (
              <div style={{ textAlign: "center", padding: "50px 0", color: "#94A3B8" }}>
                <div style={{ fontSize: "36px", marginBottom: "10px" }}>📭</div>
                <p style={{ fontSize: "14px" }}>Aucun scan pour l'instant.</p>
              </div>
            ) : (
              <div className="ch-scan-list-light">
                {visibleCrushes.map((scan) => {
                  const { cls, label } = getStatusInfo(scan);
                  return (
                    <div
                      key={scan._id}
                      className="ch-scan-row-light"
                      style={{ cursor: scan.productId || scan.barcode || scan.communityProductId || scan.external_url ? "pointer" : "default" }}
                      onClick={() => {
                        // Crush depuis un lien externe → ouvre la page produit du site
                        // "_system" : navigateur externe sous Capacitor (WebView sinon) ;
                        // en web classique c'est un simple nom de fenêtre, le lien s'ouvre pareil
                        if (scan.source === "url" && scan.external_url) {
                          window.open(scan.external_url, "_system");
                          return;
                        }
                        const navOpts = { state: { fromTab: "scans" } };
                        if (scan.scanType === "barcode" && scan.barcode) navigate(`/barcode/${scan.barcode}`, navOpts);
                        else if (scan.scanType === "community" && scan.communityProductId) navigate(`/community-product/${scan.communityProductId}`, navOpts);
                        else if (scan.productId) navigate(`/product/${scan.productId}`, navOpts);
                      }}
                    >
                      <div className="ch-scan-icon" style={{ background: "#F1F5F9" }}>
                        {scanIcon(scan.scanType)}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div className="ch-scan-name-light">{scan.articleName || "Article inconnu"}</div>
                        <div className="ch-scan-meta-light">
                          {scan.date ? new Date(scan.date).toLocaleDateString("fr-FR") : "—"}
                          {scan.city ? ` · ${scan.city}` : ""}
                        </div>
                        {scan.location_label && (
                          <span className="ch-scan-city">
                            {scan.source === "url" ? "🔗" : "🏪"} {scan.location_label}
                          </span>
                        )}
                        {scan.price && (
                          <span className="ch-scan-city">
                            💰 {scan.price}€
                            {scan.price_source === "open_prices" && (
                              <span style={{ fontSize: "10px", color: "#94a3b8", marginLeft: "4px" }}>
                                *Open Prices
                              </span>
                            )}
                          </span>
                        )}

                        {/* Community upgradé */}
                        {scan.scanType === "community" && scan.upgraded && (
                          <div className="ch-community-upgrade">
                            <p style={{ fontSize: "11px", fontWeight: 700, color: "#6D28D9", margin: "0 0 3px" }}>
                              ✨ Disponible chez {scan.vendorData?.name || "un vendeur"}
                            </p>
                            {scan.vendorData?.price != null && (
                              <span style={{ fontSize: "11px", color: "#5B21B6", fontWeight: 600 }}>
                                💶 {scan.vendorData.price} €
                              </span>
                            )}
                            {scan.vendorData?.stock && (
                              <span style={{
                                fontSize: "10px", fontWeight: 600, marginLeft: "6px",
                                color: scan.vendorData.stock === "promotion" ? "#92400E" : scan.vendorData.stock === "indisponible" ? "#991B1B" : "#065F46"
                              }}>
                                {scan.vendorData.stock === "promotion" ? "🏷️ Promotion" : scan.vendorData.stock === "indisponible" ? "🚫 Indisponible" : "✅ En stock"}
                              </span>
                            )}
                          </div>
                        )}

                        {/* Community standard */}
                        {scan.scanType === "community" && !scan.upgraded && (
                          <span className="ch-community-standard">👤 Ajouté par vous</span>
                        )}

                        {/* Barcode infos */}
                        {scan.scanType === "barcode" && scan.vendorLink?.price != null && (
                          <div style={{ fontSize: "11px", color: "#475569", marginTop: "3px" }}>
                            💶 {scan.vendorLink.price} €
                            {scan.vendorLink.customNote && (
                              <span style={{ fontStyle: "italic", marginLeft: "6px" }}>"{scan.vendorLink.customNote}"</span>
                            )}
                          </div>
                        )}

                        {scan.scanType === "barcode" && scan.ownerName && scan.ownerName !== "Inconnu" && (
                          <span style={{ fontSize: "11px", color: "#6D28D9", fontWeight: 600, display: "block", marginTop: "3px" }}>
                            🏪 {scan.ownerName}
                          </span>
                        )}

                        {scan.scanType === "barcode" && scan.vendorLink?.stock && (
                          <span style={{
                            fontSize: "10px", fontWeight: 600, marginTop: "2px", display: "block",
                            color: scan.vendorLink.stock === "promotion" ? "#92400E" : scan.vendorLink.stock === "indisponible" ? "#991B1B" : "#065F46"
                          }}>
                            {scan.vendorLink.stock === "promotion" ? "🏷️ Promotion" : scan.vendorLink.stock === "indisponible" ? "🚫 Indisponible" : "✅ En stock"}
                          </span>
                        )}

                        {/* Pas de vendeur référencé (barcode) */}
                        {scan.scanType === "barcode" && !scan.vendorLink && (
                          <span style={{ fontSize: "10px", color: "#F59E0B" }}>Aucun vendeur référencé</span>
                        )}

                        {/* Infos communautaires supplémentaires */}
                        {scan.scanType === "community" && (
                          <>
                            {scan.communityProduct?.store && (
                              <div style={{ fontSize: "11px", color: "#475569", marginTop: "3px" }}>🏪 {scan.communityProduct.store}</div>
                            )}
                            {scan.communityProduct?.note && (
                              <div style={{ fontSize: "10px", color: "#94A3B8", fontStyle: "italic", marginTop: "2px" }}>"{scan.communityProduct.note}"</div>
                            )}
                            {scan.communityProduct?.photo && (
                              <img src={scan.communityProduct.photo} alt={scan.articleName} style={{ maxHeight: "60px", objectFit: "contain", borderRadius: "6px", border: "1px solid #E2E8F0", marginTop: "6px" }} />
                            )}
                          </>
                        )}

                        {/* Image barcode */}
                        {scan.scanType === "barcode" && scan.globalProduct?.imageUrl && (
                          <img src={scan.globalProduct.imageUrl} alt={scan.articleName} style={{ maxHeight: "50px", objectFit: "contain", borderRadius: "6px", border: "1px solid #E2E8F0", marginTop: "5px" }} />
                        )}

                        {/* Image lien externe (masquée si le site bloque le hotlinking) */}
                        {scan.source === "url" && scan.external_image && (
                          <img
                            src={scan.external_image}
                            alt={scan.articleName}
                            onError={(e) => { e.currentTarget.style.display = "none"; }}
                            style={{ maxHeight: "50px", objectFit: "contain", borderRadius: "6px", border: "1px solid #E2E8F0", marginTop: "5px" }}
                          />
                        )}

                        {/* Suivi d'achat */}
                        {scan.purchased_at ? (
                          <span style={{ display: "inline-block", marginTop: "8px", fontSize: "12px", color: "#94a3b8", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "5px 10px" }}>
                            Acheté ✓
                          </span>
                        ) : (
                          <button
                            onClick={(e) => { e.stopPropagation(); markAsPurchased(scan._id); }}
                            style={{ display: "block", marginTop: "8px", fontSize: "13px", color: "#16a34a", background: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", padding: "8px 12px", cursor: "pointer" }}
                          >
                            ✓ J'ai acheté ce produit
                          </button>
                        )}

                      </div>

                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "6px", flexShrink: 0 }}>
                        {/* Pas de badge de statut sur les crushes lien externe : aucune donnée vendeur */}
                        {scan.source !== "url" && <span className={cls}>{label}</span>}
                        {/* Pas d'alertes sur les crushes lien externe : aucun barcode/produit à suivre */}
                        {scan.source !== "url" && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            const pid = scan.barcode || scan.productId;
                            const hasVendor = !!(scan.vendorLink || scan.scanType === "qr");
                            toggleProductSubscription(pid, hasVendor);
                          }}
                          style={{
                            width: "36px", height: "36px", borderRadius: "50%",
                            background: "#F1F5F9", border: "none", cursor: "pointer",
                            fontSize: "18px", display: "flex", alignItems: "center", justifyContent: "center",
                            touchAction: "manipulation", flexShrink: 0,
                          }}
                        >
                          {subsLoading ? <span style={{ opacity: 0.25 }}>🔔</span> : (productSubscriptions[scan.barcode || scan.productId] ? "🔔" : "🔕")}
                        </button>
                        )}
                        {productSubscriptions[scan.barcode || scan.productId] && !scan.vendorLink && scan.scanType !== "qr" && (
                          <span style={{ fontSize: "10px", color: "#94a3b8", textAlign: "right", maxWidth: "120px", lineHeight: 1.3, display: "block" }}>
                            Notif. active dès qu'un vendeur référencera ce produit
                          </span>
                        )}
                        <button className="ch-del-btn" onClick={(e) => { e.stopPropagation(); deleteScan(scan); }}>✕</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {scans.length > 0 && (
              <>
                <p style={{ fontSize: "11px", color: "#94a3b8", textAlign: "center", margin: "10px 0 0" }}>
                  🔔 = alertes activées &nbsp;·&nbsp; 🔕 = alertes désactivées
                </p>
                <button
                  onClick={clearHistory}
                  style={{ marginTop: "10px", width: "100%", padding: "13px", background: "#FEE2E2", color: "#DC2626", border: "none", borderRadius: "13px", fontWeight: 700, fontSize: "13px", cursor: "pointer" }}
                >
                  🗑️ Vider l'historique
                </button>
              </>
            )}
          </div>
        )}

        {/* ────────── TAB : ACHATS ────────── */}
        {activeTab === "achats" && (() => {
          const purchasedScans = scans.filter(s => s.purchased_at);
          return (
            <div>
              <div className="ch-section-header" style={{ marginBottom: "12px" }}>
                <span className="ch-section-title">Mes achats</span>
                <span style={{ fontSize: "12px", color: "#64748b" }}>Produits achetés via CrushNow</span>
              </div>

              {purchasedScans.length > 0 && (
                <div style={{ fontSize: "12px", color: "#64748b", background: "#f0fdf4", border: "1px solid #86efac", borderRadius: "20px", padding: "4px 12px", display: "inline-block", marginBottom: "14px", fontWeight: 600 }}>
                  {purchasedScans.length} produit{purchasedScans.length > 1 ? "s" : ""} acheté{purchasedScans.length > 1 ? "s" : ""}
                </div>
              )}

              {purchasedScans.length === 0 ? (
                <div style={{ textAlign: "center", padding: "50px 0", color: "#94A3B8" }}>
                  <div style={{ fontSize: "40px", marginBottom: "12px" }}>🛍️</div>
                  <p style={{ fontSize: "14px", fontWeight: 600, marginBottom: "6px" }}>Aucun achat enregistré pour l'instant.</p>
                  <p style={{ fontSize: "12px" }}>Utilise le bouton ✓ sur tes crushs !</p>
                </div>
              ) : (
                <div className="ch-scan-list-light">
                  {purchasedScans.map(scan => {
                    const delayH = scan.purchase_delay_hours;
                    let delayLabel = null;
                    if (delayH != null) {
                      if (delayH < 1) delayLabel = "acheté moins d'1h après le scan";
                      else if (delayH < 24) delayLabel = `acheté ${Math.round(delayH)}h après le scan`;
                      else delayLabel = `acheté ${Math.round(delayH / 24)}j après le scan`;
                    }
                    const isUrlCrush = scan.source === "url";
                    const imageUrl = scan.globalProduct?.imageUrl || (isUrlCrush ? scan.external_image : null);
                    return (
                      <div
                        key={scan._id}
                        className="ch-scan-row-light"
                        style={{ cursor: isUrlCrush && scan.external_url ? "pointer" : "default" }}
                        onClick={() => {
                          if (isUrlCrush && scan.external_url) window.open(scan.external_url, "_system");
                        }}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt={scan.articleName}
                            onError={(e) => { e.currentTarget.style.display = "none"; }}
                            style={{ width: "44px", height: "44px", objectFit: "contain", borderRadius: "8px", border: "1px solid #E2E8F0", flexShrink: 0, background: "white" }}
                          />
                        ) : (
                          <div className="ch-scan-icon" style={{ background: "#f0fdf4" }}>{isUrlCrush ? "🔗" : "🛍️"}</div>
                        )}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div className="ch-scan-name-light">{scan.articleName || "Article inconnu"}</div>
                          <div className="ch-scan-meta-light">
                            Acheté le {new Date(scan.purchased_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
                          </div>
                          {isUrlCrush && scan.location_label && (
                            <span className="ch-scan-city">🔗 {scan.location_label}</span>
                          )}
                          {delayLabel && (
                            <span style={{ fontSize: "11px", color: "#16a34a", fontStyle: "italic" }}>{delayLabel}</span>
                          )}
                          <button
                            onClick={(e) => { e.stopPropagation(); unmarkAsPurchased(scan._id); }}
                            style={{ display: "block", marginTop: "6px", fontSize: "11px", color: "#64748b", background: "none", border: "none", padding: 0, cursor: "pointer", textDecoration: "underline", touchAction: "manipulation" }}
                          >
                            ↩️ Remettre dans mes crushs
                          </button>
                        </div>
                        <span style={{ fontSize: "18px", flexShrink: 0 }}>✓</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })()}

        {/* ────────── TAB : CARTE ────────── */}
        {activeTab === "carte" && (
          <>
            {mapPositions.length === 0 ? (
              <div style={{ textAlign: "center", padding: "60px 0", color: "#94A3B8" }}>
                <div style={{ fontSize: "44px", marginBottom: "14px" }}>🗺️</div>
                <p style={{ fontSize: "14px", fontWeight: 500 }}>Aucun scan géolocalisé.</p>
                <p style={{ fontSize: "12px", marginTop: "6px" }}>Activez la géolocalisation avant de scanner.</p>
              </div>
            ) : (
              <>
                <div style={{ borderRadius: "16px", overflow: "hidden", border: "0.5px solid #E2E8F0", marginBottom: "12px" }}>
                  <MapContainer
                    center={mapPositions[0]?.position || defaultMapCenter}
                    zoom={6}
                    style={{ height: "55vh", width: "100%" }}
                  >
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="© OpenStreetMap" />
                    {mapPositions.map((scan, i) => (
                      <Marker key={i} position={scan.position} icon={customMarkerIcon}>
                        <Popup>
                          <strong>{scan.articleName || "Inconnu"}</strong>
                          {scan.ownerName && scan.ownerName !== "Inconnu" && (
                            <><br /><span style={{ fontSize: "12px", color: "#6D28D9", fontWeight: 600 }}>🏪 {scan.ownerName}</span></>
                          )}
                          {scan.vendorLink?.vendorId?.location?.address && (
                            <><br /><span style={{ fontSize: "11px", color: "#475569" }}>📌 {scan.vendorLink.vendorId.location.address}</span></>
                          )}
                          {scan.location_label && (
                            <><br /><span style={{ fontSize: "11px", color: "#475569" }}>{scan.location_label}</span></>
                          )}
                          {scan.city && <><br /><span style={{ fontSize: "11px", color: "#94a3b8" }}>📍 {scan.city}</span></>}
                          <br /><span style={{ fontSize: "11px", color: "#94a3b8" }}>{new Date(scan.date).toLocaleString("fr-FR")}</span>
                        </Popup>
                      </Marker>
                    ))}
                    {crushStores.map((store) => {
                      const sid = String(store._id);
                      const isFav = favoriteStores.includes(sid);
                      return (
                        <Marker key={`store-${sid}`} position={[store.lat, store.lng]} icon={storeMarkerIcon}>
                          <Popup>
                            <strong style={{ color: "#D41A6E" }}>{store.name}</strong>
                            {store.address && (
                              <><br /><span style={{ fontSize: "11px", color: "#475569" }}>📌 {store.address}</span></>
                            )}
                            <br />
                            <button
                              onClick={() => handleToggleFavoriteStore(sid)}
                              disabled={favToggling === sid}
                              style={{
                                marginTop: "8px", fontSize: "11px", fontWeight: 700,
                                padding: "4px 10px", borderRadius: "10px", border: "none",
                                cursor: favToggling === sid ? "default" : "pointer",
                                background: isFav ? "#FEE2E2" : "linear-gradient(135deg, #D41A6E, #E87010)",
                                color: isFav ? "#991B1B" : "white",
                              }}
                            >
                              {favToggling === sid ? "..." : isFav ? "Retirer des favoris" : "Ajouter aux favoris"}
                            </button>
                          </Popup>
                        </Marker>
                      );
                    })}
                  </MapContainer>
                </div>
                <div className="ch-map-stats">
                  <div className="ch-map-stat-card">
                    <span className="ch-map-stat-n">{mapPositions.length}</span>
                    <span className="ch-map-stat-l">Points enregistrés</span>
                  </div>
                  <div className="ch-map-stat-card">
                    <span className="ch-map-stat-n">{uniqueCities.length}</span>
                    <span className="ch-map-stat-l">Villes couvertes</span>
                  </div>
                </div>
              </>
            )}
          </>
        )}

        {/* ────────── TAB : PROFIL ────────── */}
        {activeTab === "profil" && (
          <>
            <UXHint
              id="client_profil"
              variant="tip"
              text="Modifie ton nom affiché en appuyant sur ✏️. Ton profil te permet aussi de suivre ta progression et tes badges."
            />
            {/* Carte utilisateur */}
            <div className="ch-profile-card">
              <div className="ch-profile-avatar">{(editNameValue || user.name || "U").split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                {editingName ? (
                  <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <input
                      ref={editNameRef}
                      className="ch-edit-name-input"
                      value={editNameValue}
                      onChange={e => setEditNameValue(e.target.value)}
                      onKeyDown={e => { if (e.key === "Enter") handleSaveName(); if (e.key === "Escape") setEditingName(false); }}
                      maxLength={60}
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="words"
                    />
                    <button className="ch-edit-name-save" onClick={handleSaveName}>✓</button>
                    <button className="ch-edit-name-cancel" onClick={() => { setEditNameValue(user?.name || ""); setEditingName(false); }}>✕</button>
                  </div>
                ) : (
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <div className="ch-profile-name">{editNameValue || user.name}</div>
                    <button className="ch-edit-name-btn" onClick={() => { setEditingName(true); setTimeout(() => { if (editNameRef.current) editNameRef.current.focus(); }, 100); }} title="Modifier le nom">✏️</button>
                  </div>
                )}
                <div className="ch-profile-id">{user._id || user.id}</div>
                {(user.registered_at || user.createdAt) && (
                  <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "2px" }}>
                    Membre depuis le {new Date(user.registered_at || user.createdAt).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
                  </div>
                )}
              </div>
            </div>

            {/* Gamification backend */}
            <GamificationBlock todayScanCount={scans.filter(s => new Date(s.date).toDateString() === new Date().toDateString()).length} />

            {/* Magasins favoris */}
            <div style={{ background: "white", borderRadius: "14px", padding: "16px", marginTop: "12px", border: "1px solid #f1f5f9" }}>
              <div style={{ fontSize: "13px", fontWeight: 700, color: "#1e293b", marginBottom: "12px" }}>
                🏪 Mes magasins favoris
              </div>
              {favoriteStores.length === 0 ? (
                <p style={{ fontSize: "12px", color: "#94a3b8", lineHeight: 1.5, margin: 0 }}>
                  Vous recevez les notifications de tous les magasins CrushNow. Ajoutez des favoris depuis la carte pour filtrer.
                </p>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  {favoriteStores.map(storeId => {
                    const info = crushStores.find(s => String(s._id) === storeId);
                    return (
                      <div key={storeId} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#fdf2f8", borderRadius: "10px" }}>
                        <span style={{ fontSize: "13px", color: "#1e293b", fontWeight: 600 }}>
                          {info ? info.name : storeId}
                        </span>
                        <button
                          onClick={() => handleToggleFavoriteStore(storeId)}
                          disabled={favToggling === storeId}
                          style={{ fontSize: "13px", color: "#D41A6E", background: "none", border: "none", cursor: "pointer", fontWeight: 700, padding: "2px 8px" }}
                        >
                          ✕
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Profil optionnel — données démographiques */}
            <div style={{ background: "white", borderRadius: "14px", padding: "16px", marginTop: "12px", border: "1px solid #f1f5f9" }}>
              <div style={{ fontSize: "13px", fontWeight: 700, color: "#1e293b", marginBottom: "14px" }}>
                👤 Profil optionnel
              </div>

              <div style={{ marginBottom: "12px" }}>
                <label style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", display: "block", marginBottom: "6px" }}>
                  Genre
                </label>
                <select
                  value={demoGender}
                  onChange={e => setDemoGender(e.target.value)}
                  style={{
                    width: "100%", padding: "10px 12px", fontSize: "14px",
                    borderRadius: "10px", border: "1px solid #e2e8f0",
                    background: "#f8fafc", color: "#1e293b", outline: "none",
                    appearance: "none", cursor: "pointer"
                  }}
                >
                  <option value="non_renseigne">Je prefere ne pas dire</option>
                  <option value="femme">Femme</option>
                  <option value="homme">Homme</option>
                  <option value="autre">Autre</option>
                </select>
              </div>

              <div style={{ marginBottom: "14px" }}>
                <label style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", display: "block", marginBottom: "6px" }}>
                  Tranche d&apos;age
                </label>
                <select
                  value={demoBirthRange}
                  onChange={e => setDemoBirthRange(e.target.value)}
                  style={{
                    width: "100%", padding: "10px 12px", fontSize: "14px",
                    borderRadius: "10px", border: "1px solid #e2e8f0",
                    background: "#f8fafc", color: "#1e293b", outline: "none",
                    appearance: "none", cursor: "pointer"
                  }}
                >
                  <option value="">Je prefere ne pas dire</option>
                  <option value="u18">Moins de 18 ans</option>
                  <option value="18-25">18-25 ans</option>
                  <option value="26-35">26-35 ans</option>
                  <option value="36-50">36-50 ans</option>
                  <option value="50+">Plus de 50 ans</option>
                </select>
              </div>

              <p style={{ fontSize: "11px", color: "#94a3b8", lineHeight: 1.5, margin: "0 0 14px" }}>
                Ces informations sont optionnelles et nous aident a ameliorer l&apos;app. Elles ne sont jamais partagees de facon identifiable.
              </p>

              <button
                onClick={handleSaveDemographics}
                disabled={demoSaving}
                style={{
                  width: "100%", minHeight: "40px", fontSize: "14px", fontWeight: 700,
                  borderRadius: "20px", border: "none", cursor: demoSaving ? "default" : "pointer",
                  background: demoSaving ? "#e2e8f0" : "linear-gradient(135deg, #D41A6E, #E87010)",
                  color: demoSaving ? "#94a3b8" : "white",
                  transition: "background 0.2s"
                }}
              >
                {demoSaving ? "Enregistrement..." : "Enregistrer"}
              </button>
            </div>

            {/* Liens légaux */}
            <div style={{ background: "white", borderRadius: "14px", padding: "4px 0", marginTop: "12px", border: "1px solid #f1f5f9" }}>
              {[
                { label: "ℹ️ À propos", path: "/about" },
                { label: "💬 Donner mon avis", path: "/feedback" },
                { label: "💡 FAQ", path: "/faq" },
                { label: "📋 Évolutions", path: "/evolutions" },
                { label: "📄 CGU", path: "/cgu" },
                { label: "🔒 Confidentialité", path: "/privacy" },
                { label: "⚖️ Mentions légales", path: "/legal" },
              ].map((link, i, arr) => (
                <Link
                  key={i}
                  to={link.path}
                  state={{ fromTab: "profil" }}
                  style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "14px 16px",
                    borderBottom: i < arr.length - 1 ? "1px solid #f8fafc" : "none",
                    cursor: "pointer", textDecoration: "none", color: "inherit"
                  }}
                >
                  <span style={{ fontSize: "14px", color: "#475569" }}>{link.label}</span>
                  <span style={{ color: "#cbd5e1" }}>›</span>
                </Link>
              ))}
            </div>

            {/* Paramètres */}
            <div className="ch-settings-card">
              <div className="ch-settings-row" onClick={togglePushSubscription}>
                <div className="ch-settings-icon">🔔</div>
                <span className="ch-settings-label">Notifications</span>
                <span className={`ch-settings-badge ${isSubscribedToPush ? "on" : "off"}`}>
                  {isSubscribedToPush ? "Activées" : "Désactivées"}
                </span>
              </div>
              <div
                className="ch-settings-row"
                onClick={() => {
                  const newState = !geolocEnabled;
                  if (!newState) {
                    setGeolocEnabled(false);
                    localStorage.setItem("geolocEnabled", "false");
                    return;
                  }
                  console.log("🌍 [GEOLOC] Début toggle — newState :", newState);
                  if (!navigator.geolocation) {
                    console.warn("🌍 [GEOLOC] navigator.geolocation absent");
                    safeToast(() => toast.error("❌ Géolocalisation non supportée sur cet appareil."));
                    return;
                  }
                  // Optimiste : on active visuellement immédiatement
                  setGeolocEnabled(true);
                  localStorage.setItem("geolocEnabled", "true");
                  console.log("🌍 [GEOLOC] Avant getCurrentPosition");
                  try {
                    navigator.geolocation.getCurrentPosition(
                      (position) => {
                        console.log("🌍 [GEOLOC] Succès position reçue", position);
                        // Permission confirmée — état déjà à true
                      },
                      (error) => {
                        console.log("🌍 [GEOLOC] Erreur", error.code, error.message);
                        // Permission refusée ou erreur — on annule
                        setGeolocEnabled(false);
                        localStorage.setItem("geolocEnabled", "false");
                        safeToast(() => toast.warn("⚠️ Permission GPS refusée. Géolocalisation désactivée."));
                      },
                      { timeout: 15000, maximumAge: 60000, enableHighAccuracy: false }
                    );
                  } catch (err) {
                    console.log("🌍 [GEOLOC] Exception", err);
                    setGeolocEnabled(false);
                    localStorage.setItem("geolocEnabled", "false");
                    safeToast(() => toast.error("❌ Erreur géolocalisation."));
                  }
                }}
              >
                <div className="ch-settings-icon">📍</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <span className="ch-settings-label">Géolocalisation</span>
                  <span style={{ fontSize: "11px", color: "#94a3b8", display: "block", marginTop: "2px" }}>
                    {geolocEnabled
                      ? "Vos scans incluent le nom du magasin. Les gérants voient des stats anonymes — jamais votre nom."
                      : "Activez pour mémoriser où vous avez scanné chaque article."}
                  </span>
                </div>
                <span className={`ch-settings-badge ${geolocEnabled ? "on" : "off"}`}>
                  {geolocEnabled ? "Activée" : "Désactivée"}
                </span>
              </div>
            </div>

            {/* Signaler un problème */}
            <ReportBugButton />

            {/* Déconnexion */}
            <button
              className="ch-logout-btn"
              onClick={() => navigate("/my-data", { state: { fromTab: "profil" } })}
              style={{ background: "#f1f5f9", color: "#475569", marginBottom: "8px" }}
            >
              🔍 Voir mes données
            </button>
            <button
              onClick={deleteAccount}
              className="ch-logout-btn"
              style={{ background: "#fee2e2", color: "#dc2626", marginBottom: "8px" }}
            >
              🗑️ Supprimer mon compte
            </button>
            <button
              className="ch-logout-btn"
              onClick={() => handleLogout("Deconnexion profil")}
            >
              Déconnexion
            </button>
          </>
        )}

      </main>

      {/* ══ BOTTOM NAV ══ */}
      <nav className="ch-nav">
        {[
          {
            tab: "accueil", label: "Accueil",
            icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
          },
          {
            tab: "scans", label: "Crushs",
            icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
          },
          {
            tab: "achats", label: "Achats",
            icon: <span style={{ fontSize: "18px", lineHeight: 1 }}>🛍️</span>
          },
          {
            tab: "carte", label: "Carte",
            icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg>
          },
          {
            tab: "profil", label: "Profil",
            icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          },
        ].map(({ tab, label, icon }) => (
          <button
            key={tab}
            className={`ch-nav-item ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {icon}
            {label}
          </button>
        ))}
      </nav>

    </div>
  );
};

// ── Gamification backend ───────────────────────────────────────────────────
const ALL_BADGES_META = [
  { id: "first_scan",        label: "Premier scan",       emoji: "🔍" },
  { id: "first_purchase",    label: "Premier achat",      emoji: "🛍️" },
  { id: "contributor",       label: "Contributeur",       emoji: "📦" },
  { id: "super_contributor", label: "Super contributeur", emoji: "🌟" },
  { id: "sharer",            label: "Partageur",          emoji: "📤" },
  { id: "viral",             label: "Viral",              emoji: "🔥" },
  { id: "faithful",          label: "Fidèle",             emoji: "💎" },
  { id: "explorer",          label: "Explorateur",        emoji: "🗺️" },
  { id: "crusheur_expert",   label: "Crusheur expert",    emoji: "🏆" },
  { id: "legend",            label: "Légende",            emoji: "👑" },
  { id: "social",            label: "Social",             emoji: "🤝" },
  { id: "fast_buyer",        label: "Achat rapide",       emoji: "⚡" },
];

function GamificationBlock({ todayScanCount = 0 }) {
  const [data, setData]       = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    axiosAuth.get("/gamification/me")
      .then(res => setData(res.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ background: "white", borderRadius: "14px", padding: "16px", marginBottom: "12px", border: "1px solid #f1f5f9" }}>
      <div style={{ fontSize: "12px", color: "#94a3b8" }}>Chargement progression…</div>
    </div>
  );
  if (!data) return null;

  const { xp, level, levelTitle, badges, nextLevel, nextLevelTitle, xpToNextLevel, progressPercent } = data;
  const unlockedIds = new Set(badges.map(b => b.id));
  const isMaxLevel = level === 7;

  return (
    <div style={{ background: "white", borderRadius: "14px", padding: "16px", marginBottom: "12px", border: "1px solid #fce7f3" }}>
      {/* Titre niveau */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
        <div>
          <span style={{ fontSize: "11px", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", color: "#94a3b8", display: "block", marginBottom: "2px" }}>
            Progression
          </span>
          <span style={{ fontSize: "17px", fontWeight: 900, color: "#0f172a" }}>
            Niveau {level} — {levelTitle}
          </span>
        </div>
        <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "linear-gradient(135deg, #D41A6E, #E87010)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", fontWeight: 900, color: "white", flexShrink: 0 }}>
          {level}
        </div>
      </div>

      {/* Barre de progression */}
      {isMaxLevel ? (
        <div style={{ textAlign: "center", fontSize: "14px", fontWeight: 700, color: "#D41A6E", padding: "8px 0", marginBottom: "14px" }}>
          🏆 Niveau maximum atteint !
        </div>
      ) : (
        <div style={{ marginBottom: "14px" }}>
          <div style={{ background: "#f1f5f9", borderRadius: "100px", height: "8px", overflow: "hidden", marginBottom: "6px" }}>
            <div style={{ height: "100%", width: `${progressPercent}%`, background: "linear-gradient(90deg, #D41A6E, #E87010)", borderRadius: "100px", transition: "width 0.6s ease" }} />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "11px", color: "#94a3b8" }}>
            <span>{xp} XP</span>
            <span>encore {xpToNextLevel} XP pour Niv.{nextLevel} — {nextLevelTitle}</span>
          </div>
        </div>
      )}

      {/* Mode d'activité du jour (déplacé depuis l'accueil, avec explication) */}
      {todayScanCount > 0 && (() => {
        const [modeIcon, modeLabel] = todayScanCount >= 5 ? ["⚡", "Mode Power User"] : todayScanCount >= 3 ? ["🔥", "Mode Actif"] : ["🌱", "Mode Découverte"];
        return (
          <div style={{ textAlign: "center", marginBottom: "14px" }}>
            <span style={{ display: "inline-block", background: "linear-gradient(90deg, #D41A6E, #E87010)", color: "white", borderRadius: "99px", padding: "4px 14px", fontSize: "12px", fontWeight: 700 }}>
              {modeIcon} {modeLabel}
            </span>
            <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0", lineHeight: 1.4 }}>
              Ton mode d'activité du jour évolue avec tes scans : 🌱 → 🔥 → ⚡
            </p>
          </div>
        );
      })()}

      {/* Badges */}
      <div style={{ fontSize: "11px", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "10px" }}>
        Badges · {badges.length} / {ALL_BADGES_META.length}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px" }}>
        {ALL_BADGES_META.map(b => {
          const earned = unlockedIds.has(b.id);
          return (
            <div key={b.id} style={{
              display: "flex", flexDirection: "column", alignItems: "center", gap: "4px",
              padding: "8px 4px", borderRadius: "10px",
              background: earned ? "#fdf2f8" : "#f8fafc",
              border: `1px solid ${earned ? "#fbcfe8" : "#e2e8f0"}`,
              opacity: earned ? 1 : 0.45,
            }}>
              <span style={{ fontSize: "20px" }}>{b.emoji}</span>
              <span style={{ fontSize: "9px", fontWeight: 700, color: earned ? "#9d174d" : "#94a3b8", textAlign: "center", lineHeight: 1.2 }}>
                {b.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ClientHistory;
